import React from 'react';
import 'react-day-picker/dist/style.css';
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {NavigationManager} from "../../managers/navigation-manager";
import {DASHBOARD} from "../../../containers/dashboard-container/dashboard-container.consts";
import {UseIoC} from "../composers/composer-plugins/use-ioc";
import {RouterController} from "../router/router-controller";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {RouteModel} from "../router/models/route-model";
import {DatePickerProps} from "./date-picker";
import {DashboardLinkParams} from "../../../containers/dashboard-container/models/dashboard-container-link-params";
import {AppModuleState} from "../../app/models/app-module.state";
import {AllScoresHashParamsModel} from "../../../containers/all-scores-container/models/all-scores.hash-params-model";

export const DatePickerComposer = (DatePicker) => UseIoC()((props: DatePickerProps) => {
  const datetimeUtils: DatetimeUtils = props.ioc.getInstance(DatetimeUtils);

  const getHashParams = (date) => {
    const filter: String = datetimeUtils.toURLDate(date);
    const diffFromToday = datetimeUtils.diffDaysByDate(date);

    let shouldUseHashParams = diffFromToday < -2 || diffFromToday > 2;
    const hashParams = shouldUseHashParams ? new AllScoresHashParamsModel({date: filter}) : null;

    return hashParams
  }

  const goto = (date: Date) => {
    if (props.onDateChange) {
      props.onDateChange(date);
      props.onChange?.(date);
      return;
    }

    const appState: AppModuleState = props.ioc.getInstance(AppModuleState);
    const navigationManager: NavigationManager = props.ioc.getInstance(NavigationManager);
    const routerController: RouterController = props.ioc.getInstance(RouterController);

    const filter: String = datetimeUtils.isToday(date) ? DASHBOARD.FILTERS.all : datetimeUtils.toURLDate(date);
    const nameForUrl = appState.context.sportType?.nameForURL || navigationManager.currentLinkModel.params.sportName;
    const params: DashboardLinkParams = new DashboardLinkParams(nameForUrl, filter);
    const linkModel: BaseLinkModel = new props.linkType(filter, params.sportName, false, false, getHashParams(date));
    const routeModel: RouteModel = routerController.findRouteByName(linkModel.name);
    const replace: Boolean = !routerController.isFormalRoute(routeModel);

    navigationManager.gotoRoute(routeModel, linkModel, replace);
    props.onChange && props.onChange(date);
  }



  return <DatePicker {...props} goto={goto} locale={datetimeUtils.locale}/>;
});
